export * from './auswertungen.page';
export * from './auswertungen.page.resolver';
